import React from 'react';

import { Button } from '../../../../shadcn/components/ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../../../../shadcn/components/ui/Dialog';

export function WeekYearUpdateDialog({
    cancelLabel = 'Cancel',
    description = '',
    isSubmitting = false,
    keepLabel = 'Keep current',
    onCancel,
    onKeep,
    onUpdate,
    open,
    title = 'Update item week/year?',
    updateLabel = 'Update week/year',
}) {
    const handleOpenChange = (nextOpen) => {
        if (isSubmitting) return;
        if (!nextOpen && typeof onCancel === 'function') {
            onCancel();
        }
    };

    return (
        <Dialog open={open} onOpenChange={handleOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    {description ? <DialogDescription>{description}</DialogDescription> : null}
                </DialogHeader>
                <DialogFooter>
                    <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
                        {cancelLabel}
                    </Button>
                    <Button type="button" variant="secondary" onClick={onKeep} disabled={isSubmitting}>
                        {keepLabel}
                    </Button>
                    <Button type="button" onClick={onUpdate} disabled={isSubmitting}>
                        {updateLabel}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

WeekYearUpdateDialog.displayName = 'WeekYearUpdateDialog';
